import React, { useState } from "react";
import { Button, Image } from "antd";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { LandingTitle } from "../../lib/styles/styleLibrary";
import shield from "../../assets/svg/shield_red.svg";
import lock from "../../assets/svg/lock_red.svg";
import Auth from "../../lib/middleware/auth";

import PinSetup from "./PinSetup";
import BvnSetup from "./BvnSetup";
import { Wrapper } from "./component";
import PropTypes from "prop-types";
import KycSetup from "./KycSetup";

const SetupWallet = (props) => {
	const user = Auth.getUser();
	const [isTransactionPin, setTransactionPin] = useState(false);
	const [isBvn, setIsBvn] = useState(false);
	const [isKyc, setIsKyc] = useState(false);

	return (
		<Wrapper>
			<LandingTitle tw="text-appPink opacity-50 text-lg! mb-2 mt-4">
				For unlimited access
			</LandingTitle>

			<h2 tw="font-semibold text-lg md:text-2xl mb-2">
				Complete wallet setup
			</h2>

			<div tw="mt-4 mb-8">
				{!user?.is_bvn_set && (
					<Button
						icon={
							<Image
								preview={false}
								src={shield}
								alt=""
								width={35}
								height={35}
								tw="p-1.5 rounded-full bg-white"
							/>
						}
						style={{ height: "3.5rem" }}
						onClick={() => {
							props.handleWalletSetup() || setIsBvn(true);
						}}
						tw="flex items-center gap-4 bg-appLightPink text-appPink rounded-2xl text-left w-full cursor-pointer text-base border border-transparent font-bold focus:ring-2 hover:(ring-2 ring-appLightPink! shadow-md)">
						Update your BVN
					</Button>
				)}

				{!user?.is_wallet_set && (
					<Button
						icon={
							<Image
								preview={false}
								src={lock}
								alt=""
								width={35}
								height={35}
								tw="p-1.5 rounded-full bg-white"
							/>
						}
						style={{ height: "3.5rem" }}
						onClick={() => {
							props.handleWalletSetup() ||
								setTransactionPin(true);
						}}
						tw="mt-4 flex items-center gap-4 bg-appLightPink text-appPink rounded-2xl text-left w-full cursor-pointer text-base border border-transparent font-bold focus:ring-2 hover:(ring-2 ring-appLightPink! shadow-md)">
						Set transaction PIN
					</Button>
				)}

				{!user?.is_kyc_verified && (
					<Button
						icon={
							<Image
								preview={false}
								src={lock}
								alt=""
								width={35}
								height={35}
								tw="p-1.5 rounded-full bg-white"
							/>
						}
						style={{ height: "3.5rem" }}
						onClick={() => {
							props.handleWalletSetup() || setIsKyc(true);
						}}
						tw="mt-4 flex items-center gap-4 bg-appLightPink text-appPink rounded-2xl text-left w-full cursor-pointer text-base border border-transparent font-bold focus:ring-2 hover:(ring-2 ring-appLightPink! shadow-md)">
						Set ID Verification
					</Button>
				)}
			</div>

			<BvnSetup isBvn={isBvn} setIsBvn={setIsBvn} />
			<PinSetup
				isTransactionPin={isTransactionPin}
				setTransactionPin={setTransactionPin}
			/>
			<KycSetup isKyc={isKyc} setIsKyc={setIsKyc} />
		</Wrapper>
	);
};

SetupWallet.propTypes = {
	handleWalletSetup: PropTypes.func,
};

SetupWallet.defaultProps = {
	handleWalletSetup: () => {
		return null;
	},
};

export default SetupWallet;
